import { bikoClient } from '@/common/apis/client';
import {
  hasBikoInsuranceDisplayData,
  type BikoPublicInsuranceData,
} from '@/modules/profile/utils/bikoInsuranceProfile';

export type { BikoPublicInsuranceData, BikoPublicInsuranceItem } from '@/modules/profile/utils/bikoInsuranceProfile';
export {
  BIMEHNAMA_APP_KEY,
  BIMEHNAMA_WIDGET_ID,
  hasBikoInsuranceDisplayData,
  isHamdastBimehnamaWidget,
} from '@/modules/profile/utils/bikoInsuranceProfile';

/**
 * Public doctor insurance from Biko (no auth).
 * Empty `{}` when doctor has no saved row — same contract as Biko service.getPublic.
 */
export async function getDoctorInsuranceFromBiko(
  userId: string | number,
  options?: { timeoutMs?: number },
): Promise<BikoPublicInsuranceData | null> {
  const uid = String(userId ?? '').trim();
  if (!uid) return null;

  try {
    const { data } = await bikoClient.get<BikoPublicInsuranceData>(
      `/v1/doctors/${encodeURIComponent(uid)}/insurance`,
      { timeout: options?.timeoutMs ?? 2000 },
    );
    if (!hasBikoInsuranceDisplayData(data)) return null;
    return data;
  } catch (error) {
    console.error('Error fetching doctor insurance from Biko:', error);
    return null;
  }
}
